"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var formatting_1 = require("../formatting/formatting");
var metrics_engine_1 = require("@tableau/metrics-engine");
var utils_1 = require("../utils");
var Localize_1 = require("../../gen-src/Localize");
var SparkLine_1 = require("../SparkLine");
var Server_Alert_List_Suspended_1 = require("../resources/Server_Alert_List_Suspended");
var engine_1 = require("../engine");
var CardDeltaLabel_1 = require("./CardDeltaLabel");
var MetricBaseCard = /** @class */ (function (_super) {
    __extends(MetricBaseCard, _super);
    function MetricBaseCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MetricBaseCard.prototype.render = function () {
        var _a;
        var measureAccessor = metrics_engine_1.buildMeasureAccessor(this.props.definition);
        if (!measureAccessor) {
            return null;
        }
        var timestampAccessor = metrics_engine_1.buildTimestampAccessor(this.props.definition);
        var comparisonAccessor = this.props.metricsReferenceLineEnabled
            ? metrics_engine_1.buildFirstThresholdMeasureAccessor(this.props.definition)
            : undefined;
        var singleNumber = utils_1.isSingleNumberMetric(this.props.data);
        var metricNumber = formatting_1.formatDataPointAsMetricNumber(measureAccessor, utils_1.getBAN(this.props.data, this.props.lastUpdatedTimestamp), this.props.measureFormat);
        var data = [];
        if (this.props.data && typeof this.props.data !== 'number') {
            data = this.props.data;
        }
        var latestValue = metrics_engine_1.getLatestValue(data);
        var definition = this.props.definition;
        var isDashedLine = ((_a = metrics_engine_1.getLineStyleForDefaultThresholdLine(this.props.definition)) === null || _a === void 0 ? void 0 : _a.lineStyle) === metrics_engine_1.LineStyle.DASHED;
        var comparisonLineStyleFromDefinition = metrics_engine_1.getStylePropsForDefaultThresholdLine(definition);
        var comparisonLineStyleToRender = isDashedLine
            ? __assign(__assign({}, targetLineStyle), comparisonLineStyleFromDefinition) : __assign({}, comparisonLineStyleFromDefinition);
        return (React.createElement("div", { "data-tb-test-id": this.props.testId, style: __assign(__assign({}, containerStyle), this.props.containerStyle) },
            React.createElement("div", { style: banAndDeltaContainerStyle },
                React.createElement("div", { "data-tb-test-id": 'metric-card-ban', style: __assign(__assign({}, (singleNumber ? singleNumberBanStyle : banStyle)), (singleNumber ? this.props.singleNumberBanStyle : this.props.banStyle)) }, (singleNumber && React.createElement("div", { style: { alignSelf: 'center' } }, metricNumber)) || metricNumber),
                this.renderComparison(measureAccessor, comparisonAccessor)),
            !utils_1.isSingleNumberMetric(this.props.data) && timestampAccessor && (React.createElement("div", { "aria-label": Localize_1.Messages.ariaTimeseriesDescription(), style: { width: '100%' } },
                React.createElement("div", { style: __assign(__assign({}, timeSeriesContainerStyle), this.props.timeSeriesContainerStyle), "aria-hidden": true },
                    React.createElement(SparkLine_1.ResizableSparkLine, { data: this.props.data, timestampAccessor: timestampAccessor, measureAccessor: measureAccessor, comparisonAccessor: comparisonAccessor, shouldRenderReferenceLine: this.props.metricsReferenceLineEnabled ? metrics_engine_1.shouldRenderFirstThresholdLine(this.props.definition) : false, formatString: this.props.measureFormat, strokeWidth: 3, color: this.props.metricColorIndicatorsEnabled ? engine_1.getColorForPoint(latestValue) : metrics_engine_1.MetricBlue, testId: "time-series", comparisonLineStyle: comparisonLineStyleToRender })))),
            React.createElement("div", { "data-tb-test-id": 'metric-card-label', style: __assign(__assign({}, labelStyle), this.props.labelStyle) }, this.renderLabel())));
    };
    MetricBaseCard.prototype.renderComparison = function (measureAccessor, comparisonAccessor) {
        var data = [];
        if (this.props.data && typeof this.props.data !== 'number') {
            data = this.props.data;
        }
        var latestValue = metrics_engine_1.getLatestValue(data);
        var delta = latestValue ? metrics_engine_1.computeMetricComparison(latestValue, measureAccessor, comparisonAccessor) : undefined;
        return (React.createElement(CardDeltaLabel_1.CardDeltaLabel, { definition: this.props.definition, comparisonDelta: delta, formatString: this.props.measureFormat }));
    };
    MetricBaseCard.prototype.renderLabel = function () {
        if (this.props.suspended) {
            return (React.createElement(React.Fragment, null,
                React.createElement("img", { src: Server_Alert_List_Suspended_1.ServerAlertListSuspendedEncodedIcon, style: { verticalAlign: 'middle', marginRight: '4px' }, "data-tb-test-id": "metric-card-suspended-warning", alt: "" }),
                Localize_1.Messages.refreshSuspended()));
        }
        else if (this.props.formattedLabel) {
            return this.props.formattedLabel;
        }
        else if (this.props.lastUpdatedTimestamp) {
            return formatting_1.formatRefreshedSince(this.props.lastUpdatedTimestamp);
        }
        else {
            return '';
        }
    };
    return MetricBaseCard;
}(React.PureComponent));
exports.MetricBaseCard = MetricBaseCard;
var timeSeriesContainerStyle = {
    width: '100%',
    height: '38px',
    paddingRight: '40px',
    marginTop: '8px',
    boxSizing: 'border-box',
};
var containerStyle = {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
};
var banAndDeltaContainerStyle = {
    textAlign: 'center',
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
};
var banStyle = {
    fontSize: '34px',
    color: metrics_engine_1.MetricBlue,
    marginBottom: '8px',
    marginTop: '32px',
    fontWeight: 'lighter',
    lineHeight: 'normal',
};
var singleNumberBanStyle = __assign(__assign({}, banStyle), { fontSize: '40px' });
var labelStyle = {
    fontSize: '12px',
    color: '#666666',
    marginTop: '10px',
    paddingBottom: '10px',
    fontWeight: 'lighter',
};
var targetLineStyle = {
    strokeLinecap: 'round',
    strokeDasharray: '1 5',
};
//# sourceMappingURL=MetricBaseCard.js.map